import React, { Component } from 'react'
import { preset } from '@services/api'
import { Collapse } from 'antd'
const { Panel } = Collapse
import Row from './Row'
import NewPrices from './NewPrices'

export default class extends Component {
    state = { policies: {} }
    componentDidMount() {
        this.update()
    }
    update = () => {
        preset.getList().then(res => {
            let policies = {}
            res.data.map(policy => (policies[policy.company_id] = { price: [] }))

            res.data.map(policy => {
                const { id, company_name, age_from, age_to, company_id, price, updated_at, updated_by } = policy
                policies[company_id] = {
                    company_name,
                    price: [
                        ...policies[company_id].price,
                        { updated_at, age_to, age_from, price, company_id, id, updated_by }
                    ] //
                }
            })
            this.setState({ policies })
        })
    }
    render() {
        return (
            <Collapse style={{ flexDirection: 'column' }} accordion>
                {Object.entries(this.state.policies).map(([id, policy]) => (
                    <Panel key={id} header={`סיעודי - ${policy.company_name}`}>
                        <Collapse style={{ flexDirection: 'column' }} accordion>
                            <Panel header={'תמחר מחיר לפי גילאים נוכחיים'}>
                                {policy.price.map(pol => (
                                    <Row
                                        policy={pol}
                                        key={pol.id}
                                        update={this.update}
                                        updatePolicy={preset.updatePolicy}
                                    />
                                ))}
                            </Panel>
                            <Panel header={'תמחר חבילה מחדש'}>
                                <NewPrices policyId={+id} update={this.update} setNewAges={preset.setNewAges} />
                            </Panel>
                        </Collapse>
                    </Panel>
                ))}
            </Collapse>
        )
    }
}
